import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { isNullOrUndefined } from '@maplecroft-typescript/utils';
import { WINDOW } from '@maplecroft-ui/ng-utils';
import { catchError, of } from 'rxjs';
import { IP_LOGIN_TOKEN_STORAGE_KEY, IP_LOGIN_TOKEN_URL } from './constants';

@Injectable({
  providedIn: 'root',
})
export class IpLoginService {
  private readonly http = inject(HttpClient);
  private readonly sessionStorage = inject(WINDOW).sessionStorage;

  public getIpAuthToken(): Promise<void> {
    return new Promise((resolve) =>
      this.http
        .post<{ access_token: string; token_type: string; expires_in: number }>(IP_LOGIN_TOKEN_URL, {})
        .pipe(catchError(() => of({ access_token: null })))
        .subscribe({
          next: ({ access_token }) => {
            if (isNullOrUndefined(access_token)) {
              this.sessionStorage.removeItem(IP_LOGIN_TOKEN_STORAGE_KEY);
            } else {
              this.sessionStorage.setItem(IP_LOGIN_TOKEN_STORAGE_KEY, access_token);
            }
            resolve();
          },
        }),
    );
  }
}
